import React, { useState } from 'react';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

const History = ({ historyData }) => {
    const [activeTab, setActiveTab] = useState(0);

    const sortedHistoryData = historyData?.every(item => item.target)
        ? historyData.sort((a, b) => a.target - b.target).slice(0, 9)
        : historyData;

    return (
        <div className="ltn__our-history-area pb-100 py-5">
            <div className="container py-2">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ltn__our-history-inner">
                            <div className="ltn__tab-menu text-uppercase">
                                <div className="nav">
                                    {sortedHistoryData?.map((item, index) => (
                                        <a
                                            key={index}
                                            className={index === activeTab ? "active show" : ""}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setActiveTab(index);
                                            }}
                                            href={`#liton_tab_2_${index + 1}`}
                                        >
                                            {item.target || item.title}
                                        </a>
                                    ))}
                                </div>
                            </div>
                            <div className="tab-content">
                                {sortedHistoryData?.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`tab-pane fade ${index === activeTab ? "active show" : ""}`}
                                        id={`liton_tab_2_${index + 1}`}
                                    >
                                        <div className="ltn__product-tab-content-inner">
                                            <div className="row">
                                                <div className="col-lg-6 align-self-center">
                                                    <div className="about-us-img-wrap about-img-left">
                                                        <ImageWithBaseApi
                                                            src={item.image}
                                                            alt="Historia artectum"
                                                            width="800px"
                                                            height="500px"
                                                            style={{ objectFit: 'cover' }}
                                                        />
                                                        <div className="ltn__history-icon">
                                                            <i className={item.icon} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 align-self-center">
                                                    <div className="about-us-info-wrap">
                                                        <div className="section-title-area ltn__section-title-2--- text-center---">
                                                            <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">{item.subtitle}</h6>
                                                            <h1 className="section-title">{item.title}</h1>
                                                        </div>
                                                        <p style={{ textAlign: 'justify' }}>{item.details}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default History;